declare global {
    interface Window {
        gtag: (command: string, targetId: string, config?: Record<string, any>) => void;
        dataLayer: any[];
    }
}

// Get GA Measurement ID from Vite environment variables
export const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || '';

// Check if GA is enabled (only if measurement ID is provided)
export const isGAEnabled = () => {
    return GA_MEASUREMENT_ID && GA_MEASUREMENT_ID.length > 0 && GA_MEASUREMENT_ID !== 'disabled';
};

// Initialize Google Analytics (simplified - assumes script is already in HTML)
export const initGA = () => {
    if (!isGAEnabled()) {
        return;
    }

    // GA script should already be loaded from index.html
    // Just verify it's working
    if (typeof window.gtag === 'undefined') {
        console.warn('Google Analytics script not found - make sure it\'s added to index.html');
    }
};

// Track page views
export const trackPageView = (path: string, title?: string) => {
    if (!isGAEnabled() || typeof window.gtag === 'undefined') return;

    window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: path,
        page_title: title || document.title,
    });
};

// Track custom events
export const trackEvent = (eventName: string, parameters?: Record<string, any>) => {
    if (!isGAEnabled() || typeof window.gtag === 'undefined') return;

    window.gtag('event', eventName, {
        event_category: 'engagement',
        ...parameters,
    });
};

// Track clicks
export const trackClick = (elementName: string, elementType: 'link' | 'button' = 'link') => {
    if (!isGAEnabled()) return;

    trackEvent('click', {
        event_category: 'UI',
        event_label: elementName,
        element_type: elementType,
    });
};

// Track form submissions
export const trackFormSubmission = (formName: string, success: boolean = true) => {
    if (!isGAEnabled()) return;

    trackEvent('form_submit', {
        event_category: 'form',
        event_label: formName,
        success: success,
    });
};

// Track assessment events
export const trackAssessment = (action: 'start' | 'complete' | 'abandon' | 'answer', data?: Record<string, any>) => {
    if (!isGAEnabled()) return;

    trackEvent(`assessment_${action}`, {
        event_category: 'assessment',
        ...data,
    });
};